import React from 'react'
import block from 'bem-cn'

import { ReactComponent as FullscreenSvg } from 'shared/img/fullscreen.svg'

import './FullscreenButton.scss'

const b = block('fullscreen-button')

interface IFullscreenButtonProps {
  toggleFullscreen: () => void
}

export const FullscreenButton: React.FC<IFullscreenButtonProps> = props => (
  <div className={b()} onClick={props.toggleFullscreen}>
    <FullscreenSvg className={b('fullscreen-icon')} />
  </div>
)
